export default {
  namespaced: true,
  state: {
    locales: [],
    selectingLocale: null,
    localesData:null,
  },
  mutations: {
    SET_LOCALES(state, data) {
      state.locales = data;
    },
    SET_SELECTING_LOCALE(state, data) {
      state.selectingLocale = data;
    },
    SET_LOCALE_DATA(state, data) {
      state.localesData = data;
    },
  },
  actions: {
    setLocales({ commit }, data) {
      commit('SET_LOCALES', data);
    },
    setSelectingLocale({ commit }, data) {
      commit('SET_SELECTING_LOCALE', data);
    },
    setLocaleData({ commit }, data) {
      commit('SET_LOCALE_DATA', data);
    },
  },
};
